export default function () {
  return [
    {
      title: 'Pracownicy',
      to: '/pracownicy',
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: '',
    },
    {
      title: 'Wyloguj się',
      htmlBefore: '<i class="material-icons">power_settings_new</i>',
      htmlAfter: '',
      to: '/wyloguj'
    }
  ];
}
